<template>
  <div class="Dashboard">
    <div class="Dashboard__buttons-wrapper">
      <v-layout align-start>
        <v-row>
          <v-col md="8">
            <SendLeads />
          </v-col>
        </v-row>
        <LeadTableFilter />

        <v-layout class="pt-3">
          <lead-form
            btnText="+ New"
            methods="create"
            :baseData="baseData"
            :type="type"
            :lead="newLead"
            v-if="type === 'life'"
          />
          <HealthLeadForm
            btnText="+ New"
            :baseData="baseData"
            :type="type"
            :lead="newHealthLead"
            v-else
          />
        </v-layout>
      </v-layout>
    </div>

    <template>
      <LeadTable source="blueberry" :type="type" />
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import LeadTable from "@/components/table/agent/LeadTable";
import LeadForm from "@/components/forms/LeadForm";
import LeadTableFilter from "@/components/filters/LeadTableFilter";
import HealthLeadForm from "@/components/forms/HealthLeadForm";
import SendLeads from "@/components/actions/SendLeads";

export default {
  name: "Dashboard",
  components: {
    LeadTable,
    LeadForm,
    LeadTableFilter,
    HealthLeadForm,
    SendLeads,
  },
  props: {
    type: String,
  },
  data() {
    return {
      newLead: {
        insurance: 0,
        gender: "m",
        tobacco: 0,
        zipcode: "",
        birth_year: "",
        birth_month: null,
        birth_day: "",
        height: null,
        weight: "",
        coverage_amount: null,
        married: 0,
        children: 0,
        howchildren: null,
        total_income: null,
        mortgage: 0,
        mortgage_remaining: null,
        state: null,
        term: null,
        rateClass: null,
        jobstatus: null,
        disability: null,
        medications: null,
        fullname: "",
        phone: "",
        email: "",
      },
      newHealthLead: {
        zip: "",
        county: "",
        contact: "",
        email: "",
        phone: "",
        address: "",
        address_2: "",
        primary: {
          name: "",
          gender: "",
          height: "",
          weight: "",
          birth_month: "",
          birth_day: "",
          birth_year: "",
          tobacco: 0,
        },
        spouse: {},
        children: [],
        credit_rating: "",
        pregnant: 0,
        treated: 0,
        hospitalized: 0,
        self_employed: 0,
        prescription_medications: "",
        household_income: 75000,
        medications: [],
        qualifying_life_event: "",
        qualifying_life_event_date: "",
        denied_coverage: 0,
        lost_coverage: 0,
        currently_insured: 0,
        health_current_company: "",
        coverage_type: "",
      },
    };
  },
  methods: {
    ...mapMutations({
      SET_STATE_FILTER: "filters/SET_STATE_FILTER",
      SET_STATUS_FILTER: "filters/SET_STATUS_FILTER",
      SET_AGENT_FILTER: "filters/SET_AGENT_FILTER",
      SET_SOURCE_FILTER: "filters/SET_SOURCE_FILTER",
    }),
    ...mapActions({
      loadLeadsByFilters: "leads/loadLeadsByFilters",
      loadStatuses: "statuses/loadStatuses",
      loadStates: "states/loadStates",
      loadAgents: "agents/loadAgents",
      loadSources: "sources/loadSources",
    }),
  },
  created() {
    this.sockets.subscribe("CREATE_LEAD", () => {});
    this.sockets.subscribe("UPDATE_LEADS", () => {});
    this.sockets.subscribe("DELETE_LEAD", () => {});
    if (!localStorage.getItem("leadFilters")) {
      const statusesLoaded = this.loadStatuses().then((statuses) => {
        this.SET_STATUS_FILTER(statuses.map((s) => s.id));
      });
      const statesLoaded = this.loadStates().then((states) => {
        this.SET_STATE_FILTER(states.map((s) => s.id));
      });
      const sourcesLoaded = this.loadSources().then(() => {
        this.SET_SOURCE_FILTER(1);
      });
      Promise.all([statusesLoaded, statesLoaded, sourcesLoaded]).then(() => {
        this.SET_AGENT_FILTER([this.user.id]);
        this.loadLeadsByFilters({params: this.leadFilters, page: this.currentPage});
      });
    } else {
      this.loadStatuses();
      this.loadStates();
      this.loadSources();
      this.loadLeadsByFilters({params: this.leadFilters, page: this.currentPage});
    }
  },
  computed: {
    ...mapGetters({
      baseData: "baseData/baseData",
      user: "auth/user",
      leadsIsLoad: "leads/leadsIsLoad",
      leadFilters: "filters/leadFilters",
      currentPage: "leads/currentPage"
    }),
  },
};
</script>
